function init() {
    registerSearchResetClick();
}

function registerSearchResetClick() {
    var newsSearchForm = document.getElementById('news-search-form');
    var resetButton = document.querySelector('#news-search-form .clear-btn');
    if (newsSearchForm && resetButton) {
        resetButton.addEventListener('click', function (e) {
            e.preventDefault();
            var inputs = document.querySelectorAll('#news-search-form input');
            for (let elem of inputs) {
                elem.value = '';
            }
            var selects = document.querySelectorAll('#news-search-form select');
            for (let elem of selects) {
                elem.selectedIndex = null;
            }
        $("button.btn.btn--tertiary").click();
        });
    }
}

export default {
    init: init
}